<template>
  <div class="form1">
    <div style="width: 100%; height: 15px"></div>
    <h1 style="padding: 10px; text-align: center">提交表单获取学费报价</h1>
    <div style="width: 100%; height: 15px"></div>
    <el-input
      placeholder="请输入你的姓名"
      prefix-icon="el-icon-user"
      v-model="username"
      style="width: 100%; margin-bottom: 20px"
    ></el-input>
    <div style="width: 100%; height: 15px"></div>
    <el-input
      placeholder="请输入你的手机号"
      prefix-icon="el-icon-mobile-phone"
      v-model="mobile"
      type="tel"
      style="width: 100%; margin-bottom: 20px"
    ></el-input>
    <div style="width: 100%; height: 15px"></div>
    <el-button
      type="primary"
      :loading="loading"
      style="width: 100%"
      :style="{ background: '#8d6e63', borderColor: '#8d6e63' }"
      @click="send"
      >{{ buttonWords }}</el-button
    >
    <p style="text-align: center; padding: 15px; font-size: 15px">
      <i style="color: red">*</i>凭有效电话获取课程学费报价
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      mobile: "",
      loading: false,
      buttonWords: "获取学费",
      ruleValidate: {
        username: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
          {
            max: 10,
            message: "姓名不能超过十个字",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    mobile: "checkMobile",
  },
  methods: {
    checkMobile() {
      let m = this.mobile;
      let valid_rule =
        /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (m.length > 10) {
        if (!valid_rule.test(this.mobile)) {
          this.$Message.error("手机号格式错误");
          return false;
        }
      }
    },
    send() {
      //检查表单
      this.loading = true;
      let valid_rule =
        /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = "获取学费";
        
      }, 1500);
      if (this.username == "" || this.mobile == "") {
        this.$Message.error("请完整填写");
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        this.$Message.error("手机号格式错误");
        return false;
      } 
      this.buttonWords = "";
      this.loading = true;
      this.$Message.success("提交成功");
      
      this.$axios
        .get("http://api.cdomick.com/index.php/form/insert", {
          params: {
            name: this.username,
            mobile: this.mobile,
            laiyuan: document.referrer,
            first: window.location.href,
          },
        })
        .then(function (response) {
          console.log(response.data.code);
          if (response.data.code == 1) {
            console.log(123123)
            // this.$Message.success("提交成功");
            this.loading = false;
            this.clearForm
            location.reload();
          } else {
            console.log(22222)
            //this.$Message.success("提交成功");
            this.loading = false;
            this.clearForm
            location.reload();
          }
        })
        .catch(function () {
          location.reload();
        });
    },
    clearForm() {
      this.username = "";
      this.mobile = "";
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .poptip2 {
  height: 260px;
}
</style>